<template>
  <section>
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ formTitle }}
          </p>
        </header>
        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group
              name="name"
              :label="$t('attributes.name')"
              :label-position="labelPosition"
            >
              <b-input
                v-model="form.name"
                name="name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.name')
                "
                expanded
              ></b-input>
            </form-group>
            <form-group
              name="display_name"
              :label="$t('attributes.display_name')"
              :label-position="labelPosition"
            >
              <b-input
                v-model="form.display_name"
                name="display_name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.name')
                "
                expanded
              ></b-input>
            </form-group>
            <form-group
              name="type"
              attribute="attributes.traveler_bed_type"
              :label="$t('attributes.traveler_bed_type')"
              :label-position="labelPosition"
              expanded
            >
              <b-select
                v-model="form.type"
                name="type"
                :placeholder="
                  $t('message.please_select') +
                    $t('attributes.traveler_bed_type')
                "
                expanded
              >
                <option v-for="type in bed_types" :value="type" :key="type">
                  {{ bedTypeName(type) }}
                </option>
              </b-select>
            </form-group>
            <div class="columns mb-0">
              <div class="column">
                <form-group
                  name="age_min"
                  :label="$t('attributes.age_min')"
                  :label-position="labelPosition"
                >
                  <b-input
                    v-model="form.age_min"
                    name="age_min"
                    type="number"
                    min="0"
                    :placeholder="
                      $t('message.please_input') + $t('attributes.age_min')
                    "
                    expanded
                  ></b-input>
                </form-group>
              </div>
              <div class="column">
                <form-group
                  name="age_max"
                  :label="$t('attributes.age_max')"
                  :label-position="labelPosition"
                >
                  <b-input
                    v-model="form.age_max"
                    name="age_max"
                    type="number"
                    min="0"
                    :placeholder="
                      $t('message.please_input') + $t('attributes.age_max')
                    "
                    expanded
                  ></b-input>
                </form-group>
              </div>
            </div>
          </form-wrapper>
        </section>
        <footer class="modal-card-foot">
          <b-button class="is-fullwidth" @click="$parent.close()">
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="sending"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{ isCreate ? $t('attributes.add') : $t('attributes.update') }}
          </b-button>
        </footer>
      </div>
    </form>
  </section>
</template>

<script>
import { maxLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'TravelerTypesForm',
  props: {
    travelerType: {
      type: Object,
      required: true
    },
    isCreate: {
      type: Boolean
    }
  },
  data() {
    return {
      bed_types: ['Bed', 'NoBed', 'AddBed', 'Infant'],
      labelPosition: 'on-border',
      sending: false,
      form: this.extractFormValues(this.travelerType)
    }
  },
  computed: {
    formTitle() {
      let title = !this.isCreate
        ? this.$t('attributes.modify')
        : this.$t('attributes.add')
      title += this.$t('attributes.traveler_type')
      return title
    }
  },
  watch: {
    travelerType(newTravelerType) {
      this.form = this.extractFormValues(newTravelerType)
    }
  },
  validations: {
    form: {
      id: {},
      age_min: {},
      age_max: {},
      name: { required, maxLength: maxLength(50) },
      display_name: { required, maxLength: maxLength(50) },
      type: {}
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        id: data.id,
        age_min: data.age_min,
        age_max: data.age_max,
        name: data.name,
        display_name: data.display_name || data.name,
        type: data.type || 'Bed'
      }
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
